
<template>
  <article class="performance-product-formula-value-calculator">
    <AppContainer>
      <S10YieldCalculation
        v-if="product === 'MicroEssentials S10®'"
        :performanceProductFormula="productFormula"
        :previousCalculator="previousCalculator"
      />
      <S15YieldCalculation
        v-else-if="product === 'MicroEssentials S15®'"
        :performanceProductFormula="productFormula"
        :previousCalculator="previousCalculator"
      />
      <SZYieldCalculation 
        v-else
        :performanceProductFormula="productFormula"
        :previousCalculator="previousCalculator"
      /> 
    </AppContainer>
  </article>
</template>

<script>
import { format } from 'date-fns';

import AppContainer from '@/components/shared/AppContainer';
import AppHeading from '@/components/shared/AppHeading';
import SZYieldCalculation from '@/components/SZYieldCalculation';
import S10YieldCalculation from '@/components/S10YieldCalculation';
import S15YieldCalculation from '@/components/S15YieldCalculation';

export default {
  components: {
    SZYieldCalculation,
    S10YieldCalculation,
    S15YieldCalculation,
    AppContainer,
    AppHeading
  },
  props: {
    productFormula: {
      type: Object,
      required: true
    },
    product: {
      type: String,
      required: true
    },
    logo: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      previousCalculator: null,
      image: window.host_domain + '/icons/mosaic-pdf.png'
    };
  },
  mounted() {
    // console.log(this.productFormula);
    // const file = '~/pages/products/calculatorGtag.js';
    // window.dataLayer = window.dataLayer || [];
    // function gtag() {
    //   dataLayer.push(arguments);
    // }
    // gtag('js', new Date());
    // gtag('config', 'UA-27592348-3');
  },
  provide() {
    return {
      getPdfEl: () => this.$el
    };
  },
  head() {
    const title = this.product + ' Value Calculator';
    const description = this.product + ' Value Calculator';
    return {
      title,
      meta: [
        { name: 'description', content: description },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'robots', content: 'noindex' }
      ]
    };
  }
};
</script>

<style lang="scss">
/* autoprefixer grid: autoplace */
.performance-product-formula-value-calculator {
  .print {
    display: none;
  }

  &.pdf {
    padding: 0;
    width: 96%;

    .print {
      display: block;
      > * {
        display: block;
      }
    }

    .print-hide {
      display: none;

      > * {
        display: none;
      }
    }

    .print-wrapper {
      display: grid;
      grid-template-columns: 36% 64%;
      grid-template-rows: 1fr;
      margin: 0 auto;
      width: 100%;
    }

    .print-left {
      height: 100%;
      width: 100%;
      background-color: rgba(115, 115, 115, .1);
      padding: 16px 24px 36px 16px;

      .print-personalization {
        display: block;
        height: 100%;
        width: 100%;
      }

      .align-bottom {
        color: #000;
        font-size: 1.2rem;
      }
    }

    .print-right {
      display: flex;
      justify-content: center;
      padding-bottom: 1rem;

      .print-detail-right {
        width: 78%;
      }
    }

    .pm {
      margin: 1rem 0 3rem;
    }

    .pmb {
      margin-bottom: 3rem;
    }

    .pmt {
      margin-top: 1rem;
    }

    .input-value {
      @include font('trade-gothic', 'bold');
      border: 0;
      border-radius: 4px;
      color: color('new-gold');
      display: inline;
      font-size: 3rem;
      margin-right: 0.5rem;
      padding: 0.25rem 0.5rem;
      position: relative;
      width: 100px;
    }

    small {
      &.smaller {
        font-size: 1.25rem;
        margin-left: .7rem;
        position: relative;
        top: .3rem;
      }
    }

    .calc-logo {
      margin-bottom: 0.75rem;
      width: 105px;
    }

    .print-logo {
      display: block;
      height: auto;
      overflow: visible;
      width: 140px;
    }

    .print-header {
      padding-bottom: 1rem;
    }

    .print-footer {
      padding: 1rem 0;
    }

    .footer__copyright {
      text-align: center;
    }

    .footer__grid--header {
      align-items: center;
      display: flex;
      justify-content: space-between;
      padding: 0 3rem;

      .crop-calculator__header-h1 {
        margin-bottom: 0;

        @include breakpoint('md') {
          font-size: 3.5rem;
          font-weight: bold;
        }
      }
    }

    .container.container--gutter {
      margin: 0;
      max-width: 100%;
      padding: 0;
      width: 100%;
    }

    .crop-calculator {
      min-height: auto !important; /* stylelint-disable-line declaration-no-important */
    }

    .crop-calculator__info,
    .crop-calculator__no-border,
    .crop-calculator__options {
      border: 0;
      margin: 5px;
      padding: 5px;
    }

    .crop-calculator__calculator {
      display: none;
    }

    .crop-calculator__additional-totals {
      .heading--xs {
        @include font-size('subheading', 'sm');
      }

      .heading--sm {
        font-size: 2.1rem;
      }
      small {
        font-size: 2.1rem;
      }
    }

    .crop-calculator__input--price {
      .crop-calculator-heading {
        font-size: 1rem;
        font-weight: bold;
      }

      .heading--spacing-lg {
        margin-bottom: 0.7rem;
      }
    }

    .growler-text {
      font-size: 3rem;
      line-height: 40px;
    }

    .crop-calculator__add-col {
      padding: 1.2rem 0 1rem;
    }
    .crop-calculator__results-heading {
      font-size: 2.25rem;
      margin: 0 0 2.5rem;

      &.heading--sm {
        font-size: 2.25rem;
      }
    }

    .crop-calculator__roi {
      margin-right: 5%;
      position: relative;

      > div {
        top: 0 !important; /* stylelint-disable-line declaration-no-important */
      }

      h3 {
        font-size: 1.7rem;
        margin-bottom: 0.4rem;
      }

      h4 {
        font-size: 3rem;
        margin-bottom: 0.5;
      }

      .flex-row {
        flex-wrap: nowrap;
        margin: .3rem 0 1rem;
      }
    }

    .progress-circle {
      margin: 0 auto -1rem;
      max-width: 25rem;
      padding-bottom: 0;
    }

    .progress-circle__slot {
      h4 {
        margin-bottom: 0.5rem;
      }
    }

    .crop-calculator__slider {
      display: none;
    }
  }

  &__header {
    text-align: center;

    h1 {
      font-size: 2.65rem;
      margin-bottom: 2.45rem;
    }
  }

  &__subheading {
    .subheading {
      font-size: 1.25rem;
    }
  }

  &__grid {
    display: grid;
    grid-gap: spacing('lg');
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, auto);

    @media (min-width: 960px) {
      grid-gap: spacing('xl');
      grid-template-columns: 20rem 30rem;
      grid-template-rows: 1fr;
    }
  }
}
</style>
